import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    // Initialize data or any other logic if needed
  };

  return (
    <div className="homepage-container">
      <div className="header-and-buttons">
        <h1>Kontrollportalen</h1>
        <div className="homepage-btn-container">
          <Link to="/review-suppliers" className="btn homepage-btn">Granska leverantörer</Link>
          <Link to="/follow-up" className="btn homepage-btn">Uppföljning</Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
